module.exports = __webpack_public_path__ + "media/images/lb/402-7ca92eb2693b5e774223c24dcb9a0465.svg";